import { graphql } from 'react-relay';

const PixAutomaticApproved = graphql`
  subscription PixAutomaticApprovedSubscription(
    $input: PixAutomaticApprovedInput!
  ) {
    PixAutomaticApproved(input: $input) {
      paymentSubscription {
        id
        isActive
      }
    }
  }
`;

export { PixAutomaticApproved };
